import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM_Mapper extends BaseFormMapper<HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM);

		return _formData;
	}

	MapValues(): Partial<HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM> {
		return {};
	}
}

const Mappings: HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM = {
	newPaymentFrequencyChangeFeeToMTG: 'New Payment Frequency fee to mtg',
	newPaymentFrequencySentWithForm: 'New Payment Frequency sent with form',
	newDateChangeSentWithForm: 'New date change sent with form',
	newDateChangeFeeToMTG: 'New date change fee to mtg',
	paymentDateChange: 'Payment date change',
	paymentFrequencyChange: 'Payment frequency change',
	// "6":"Print",
	firstPaymentExtractedOnDayOfMonth:
		'Biw first payment being extracted on Day of the month',
	interestAdjustmentAmount: 'Interest Adjustment Amount',
	monthly: 'Monthly',
	biweekly: 'Biweekly',
	acceleratedBiweekly: 'Accelerated Biweekly',
	mail: 'Mail',
	email: 'E-mail',
	fax: 'Fax',
	paymentFrequency: 'Current Payment Frequency',
	contactPhoneNumber2: 'Contact Phone Number_2',
	contactPhoneNumber: 'Contact Phone Number',
	borrowerName2: 'Name of Borrower Print_2',
	borrowerName: 'Name of Borrower Print',
	dayOf: 'day of',
	signedThis: 'Signed this',
	firstPaymentExtractedOnDayOfMonth2:
		'with first payment being extracted on Day of the month_2',
	acceleratedBiweeklyDayOfWeek: 'Accelerated Biweekly Day of the week',
	biweeklyDayOfWeek2: 'Biweekly Day of the week_2',
	startingTheMonthOf: 'starting the month of',
	monthlyDayOfMonth2: 'Monthly Day of the month_2',
	newDateChangeTo: 'Please change my payment date to the',
	lastPaymentReceived: 'Last payment received',
	biweeklyDayOfWeek: 'Biweekly Day of the week',
	monthlyDayOfMonth: 'Monthly Day of the month',
	propertyAddress: 'Property Address',
	mortgageNumber: 'Mortgage Number',
	to: 'To',
	year: '20',
};

export interface HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM {
	to: string;
	fax: string;
	email: string;
	mail: string;
	mortgageNumber: string;
	propertyAddress: string;

	paymentFrequency: string;

	monthlyDayOfMonth: string;
	biweeklyDayOfWeek: string;
	lastPaymentReceived: string;

	paymentDateChange: string;
	newDateChangeSentWithForm: string;
	newDateChangeFeeToMTG: string;
	newDateChangeTo: string;

	paymentFrequencyChange: string;
	newPaymentFrequencySentWithForm: string;
	newPaymentFrequencyChangeFeeToMTG: string;

	monthly: string;
	monthlyDayOfMonth2: string;
	startingTheMonthOf: string;

	biweekly: string;
	biweeklyDayOfWeek2: string;
	firstPaymentExtractedOnDayOfMonth: string;

	acceleratedBiweekly: string;
	acceleratedBiweeklyDayOfWeek: string;
	firstPaymentExtractedOnDayOfMonth2: string;

	interestAdjustmentAmount: string;

	signedThis: string;
	dayOf: string;
	year: string;

	borrowerName: string;
	contactPhoneNumber: string;
	borrowerName2: string;
	contactPhoneNumber2: string;
}
